import { render } from "./B2BSection.vue?vue&type=template&id=3357436a&scoped=true"
const script = {}

import "./B2BSection.vue?vue&type=style&index=0&id=3357436a&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3357436a"]])

export default __exports__